import React, { useState } from "react";
import NipWrapper from "../../components/Nip/NipWrapper";
import { copyTextFunction } from "../../utils/Functions/copyTextFunction";

const LiveEnvironment = () => {
  const [state, setState] = useState({
    copied: false,
    index: "",
  });

  const key = "sk_test_a41402155aba8fd370ccc170d665c0f7bd103bc9";

  const myFunction = copyTextFunction(setState);

  return (
    <NipWrapper>
      <div className="live-env">
        <div className="live-env-title">NIP Live Environment</div>
        <div className="live-env-sub-title">
          Run tests, requests and responses, make API Calls and perform other
          related activities.
        </div>
        <div className="live-env-info-box">
          <div className="live-env-info-box-circle">i</div>
          <div className="live-env-info-box-text">
            These keys are for testing only. Please <span>DO NOT</span> use them
            in production.
          </div>
        </div>

        <div className="live-env-key">
          <div className="live-env-key-title">Test Secret Key</div>
          <div className="live-env-key-box">
            <span className="live-env-key-box-details">{key}</span>
            <span
              className="live-env-key-box-copy"
              data-testid="myFunction"
              onClick={() => myFunction(key)}
            >
              {state.copied ? "COPIED!" : "COPY"}
            </span>
          </div>
        </div>
      </div>
    </NipWrapper>
  );
};

export default LiveEnvironment;


